import { Component, OnInit, ViewChild } from '@angular/core';
import { SupportService } from '../../services/support.service';
import { BsModalComponent } from 'ng2-bs3-modal';
import { Router } from '@angular/router';
import { PrincipalService } from '../../../../shared';

@Component({
  selector: 'app-config',
  templateUrl: './app-config.component.html',
  styleUrls: ['./app-config.component.css']
})
export class SupportAppConfigComponent implements OnInit {

  public appConfigs;
  public hideModal: boolean = true;
  public deleteConfirmModal: boolean = true;

  public isUpdate: boolean = false;
  public isDelete: boolean = false;
  public addData;
  public addSuccess: boolean = false;
  public serverError: boolean = false;
  public configKey1;
  public configSubKey1;
  public configValue1;
  public configDescription1;
  public appConfig;
  @ViewChild('addConfig')
  modal: BsModalComponent;

  @ViewChild('deleteConfig')
  modal2: BsModalComponent;

  public message;
  public deleteMessage;
  public selectedRow;

  constructor(public support: SupportService,
              public principal: PrincipalService,
              public router: Router) {
    this.appConfig = {};
    this.principal.identity(true).then((account) => {
      this.serverError = false;
      if (account == null) {
        this.router.navigate(['login']);
        this.serverError = true;
      }
    }, (error) => {
      this.router.navigate(['login']);
      this.serverError = true;
    });
  }

  ngOnInit() {
    this.getAllConfigs();
  }

  public openConfigModal() {
    this.isUpdate = false;
    this.clear();
    this.modal.open();
  }

  public createConfig() {
    this.isDelete = false;
    this.support.addConfig(this.appConfig).subscribe(
      data => {
        this.serverError = false;
        this.addSuccess = true;
        if (this.isUpdate) {
          this.message = 'Value edited Successfully';
        } else {
          this.message = 'Value Added Successfully';

        }
        this.getAllConfigs();
        this.clear();
      },
      (error) => {
        this.serverError = true;
        this.addSuccess = false;
      });
  }

  public editConfig(appConfig) {
    this.isUpdate = true;
    this.support.getAppConfigById(appConfig.key, appConfig.subKey).subscribe(
      data => {
        this.serverError = false;
        this.appConfig = data;
        this.openModal();

      }, (error) => {
        this.serverError = true;
      })
  }

  public deleteConfigById(appConfig) {
    this.open2Modal();
    this.selectedRow = appConfig;
  }

  public deleteConfirmed(appConfig) {
    this.isDelete = true;
    this.addSuccess = false;
    this.support.deleteConfigById(appConfig.key, appConfig.subKey).subscribe(data => {
      this.serverError = false;
      this.getAllConfigs();
    }, (error) => {
      this.serverError = true;
    })
  }

  public clear() {
    this.appConfig = {key: null, subKey: null, value: null, description: null};
  }

  public checkSubmit() {
    this.getAllConfigs();
  }

  public getAllConfigs() {
    this.support.getAppConfigs()
      .subscribe(
        (response) => {
          this.serverError = false;
          this.appConfigs = response;
          if (this.isDelete) {
            this.deleteMessage = 'Value deleted Successfully';
          }
        },
        (error) => {
          this.serverError = true;
        }
      );
  }

  public openModal() {
    this.modal.open();
  }

  public open2Modal() {
    this.modal2.open();
  }
}
